import { useMemo } from "react";
import { useEvidenceDocuments, useProjectDocuments, type EvidenceDocument } from "@lumanity/ui/evidence";

/** The project's Evidence Base documents, sorted by name, and a lookup by id. */
export function useProjectEvidence(projectId: string) {
  const projectDocs = useProjectDocuments(projectId);
  const allDocs = useEvidenceDocuments();
  return useMemo(() => {
    const ids = new Set(projectDocs.data?.documentIds ?? []);
    const documents = (allDocs.data ?? []).filter((d) => ids.has(d.id)).sort((a, b) => documentName(a).localeCompare(documentName(b)));
    return {
      documents,
      byId: new Map(documents.map((d) => [d.id, d])),
      isLoading: projectDocs.isLoading || allDocs.isLoading,
      error: projectDocs.error ?? allDocs.error,
    };
  }, [projectDocs.data, projectDocs.isLoading, projectDocs.error, allDocs.data, allDocs.isLoading, allDocs.error]);
}

export const documentName = (doc: Pick<EvidenceDocument, "title" | "filename">) => doc.title?.trim() || doc.filename;
